//@flow
/**
 * Quiz reducer
 * @module quiz/reducer
 */
import { Record } from 'immutable'

export const QUIZ_CONNECTION = 'QUIZ_CONNECTION'

export type Action = { type: 'QUIZ_CONNECTION', payload: boolean }

const QuizRecord = Record({
  connected: false,
})

/**
 * handles connection status
 * @memberof quiz/reducer
 */
export default function QuizReducer(
  state: QuizRecord = new QuizRecord(),
  action: Action,
): QuizRecord {
  switch (action.type) {
    case QUIZ_CONNECTION: {
      return state.set('connected', action.payload)
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/quiz/reducer.js